var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.233,
    height: 15.135,
    viewBox: "0 0 12.233 15.135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.7 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M68.8,6.866h2.568a1.258,1.258,0,0,0-.191-.239L68.639,4.091A1.568,1.568,0,0,0,68.4,3.9V6.452A.4.4,0,0,0,68.8,6.866Z",
    transform: "translate(-47.657 -1.177)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.142,6.758a1.463,1.463,0,0,1-1.467-1.467V2.5H13.119A1.416,1.416,0,0,0,11.7,3.919v12.3a1.423,1.423,0,0,0,1.419,1.419h9.394a1.423,1.423,0,0,0,1.419-1.419V6.758ZM16.708,3.9a.574.574,0,1,1-.574.574A.582.582,0,0,1,16.708,3.9ZM14.2,7.077l1.116-1.85a.226.226,0,0,1,.4,0L16.4,6.36l.4-.67a.226.226,0,0,1,.4,0l.829,1.388a.23.23,0,0,1-.207.351H14.411A.24.24,0,0,1,14.2,7.077Zm7.241,7.99a.245.245,0,0,1-.239.239H14.427a.245.245,0,0,1-.239-.239v-.622a.245.245,0,0,1,.239-.239h6.778a.245.245,0,0,1,.239.239Zm0-2.616a.245.245,0,0,1-.239.239H14.427a.245.245,0,0,1-.239-.239V11.83a.245.245,0,0,1,.239-.239h6.778a.245.245,0,0,1,.239.239Zm0-2.616a.245.245,0,0,1-.239.239H14.427a.245.245,0,0,1-.239-.239V9.214a.245.245,0,0,1,.239-.239h6.778a.245.245,0,0,1,.239.239Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.6f5322d99178646addcb714792e4daef.svg";
export { ForwardRef as ReactComponent };